module.exports = __webpack_public_path__ + "img/logo.d81c2d1b.png";